
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 3.75l-.594.438-4 3L5 7.5V13h10V7.5l-.406-.313-4-3zm0 2.5l3 2.25V11H7V8.5zM5 14v14h2V14zm8 0v2H8v2h5v2H8v2h5v2H8v2h5v2h2V14zm3 0v2c1.438 0 1.969.46 2.5 1.375.531.914.86 2.348 1.25 3.875.39 1.527.855 3.16 1.938 4.5C22.77 27.09 24.538 28 27 28v-2c-2.016 0-3.012-.59-3.75-1.5s-1.188-2.277-1.563-3.75c-.375-1.473-.66-3.04-1.437-4.375C19.473 15.039 18.016 14 16 14z"}})])
          )
        }
      }
    